import { defineStore } from 'pinia';

interface MypageState {
  client: api.client.getInfo.client;
  center: api.client.getInfo.center;
  group: api.client.getInfo.group;
  unit: api.client.getInfo.clientUnitInfo;
  tos: api.client.getInfo.tos;
}

const initialClient = (): api.client.getInfo.client => ({
  name: '',
  email: '',
  phoneNumber: '',
  joinType: 'normal',
});

const initialCenter = (): api.client.getInfo.center => ({
  centerId: '',
  jibunAddress: '',
  roadAddress: '',
  detailAddress: '',
  dongName: '',
  latitude: 0,
  longitude: 0,
  postalCode: '',
  detailAddressEng: '',
  jibunAddressEng: '',
  roadAddressEng: '',
});

const initialGroup = (): api.client.getInfo.group => ({
  groupId: null,
  memberRole: '',
  memberStatus: '',
});

const initialUnit = (): api.client.getInfo.clientUnitInfo => ({
  participantUnitId: null,
  unitRole: '',
  groupRoles: [''],
  pendingGroups: [],
  clientId: '',
});

export const useMypageStore = defineStore('mypage', {
  state: (): MypageState => ({
    client: initialClient(),
    center: initialCenter(),
    group: initialGroup(),
    unit: initialUnit(),
    tos: { marketing: null },
  }),

  actions: {
    updateClient(payload: api.client.getInfo.client) {
      this.client = payload;
    },
    updateCenter(payload: api.client.getInfo.center) {
      this.center = payload;
    },
    updateGroup(payload: api.client.getInfo.group) {
      this.group = payload;
    },
    updateMarketing(payload: boolean | null) {
      this.tos.marketing = payload;
    },
    updateUnit(payload: any) {
      this.unit = payload.clientUnitInfo;
    },
    resetClient() {
      this.client = initialClient();
    },
    resetCenter() {
      this.center = initialCenter();
    },
    resetGroup() {
      this.group = initialGroup();
    },
    resetMarketing() {
      this.tos.marketing = null;
    },
    resetUnit() {
      this.unit = initialUnit();
    },
  },
});
